"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// This package is deprecated.
// All exports here are just for backward compatibility.
// Please use type from their real packages directly
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
exports.HtmlSanitizer = roosterjs_editor_dom_1.HtmlSanitizer;
exports.htmlToDom = roosterjs_editor_dom_1.htmlToDom;
exports.splitWithFragment = roosterjs_editor_dom_1.splitWithFragment;
exports.getInheritableStyles = roosterjs_editor_dom_1.getInheritableStyles;
//# sourceMappingURL=index.js.map